import { actionCreator } from "src/store/dataService/actions/utils/actionCreator";
import { API } from "src/store/dataService/types";
import { AccessoryPayments } from "Types/api/AccessoryPayments";

export const getAccessoriesPaymentsRequest = actionCreator(
    "accessories_payments/get/request",
    (uuid: string, vin: string) => ({
        uuid,
        vin,
    }),
    () => ({ route: API.AccessoriesPayments })
);

export const getAccessoriesPaymentsSuccess = actionCreator(
    "accessories_payments/get/success",
    (vin: string, response: { payments: AccessoryPayments[] }) => ({
        vin,
        payments: response.payments,
    })
);

export const getAccessoriesPaymentsFailure = actionCreator("accessories_payments/get/failure", (vin: string) => ({
    vin,
}));
